export default __webpack_public_path__ + "static/media/fad-filter-bandpass.3b6a5ffc.svg";